import { MentionCustomizationModel } from './mention-customization.model';
import { DefaultFontsEnum } from '../../../Common/PageBuilder/enums/default-fonts.enum';
import { BriefingStyleStateEnum } from '../../../Common/MonitorShared/enum/briefing-style-state.enum';
import { MonitoringTextStyleModel } from './monitoring-text-style.model';
import { MonitoringDateStyleModel } from './monitoring-date-style-model';
import { FontAlignmentEnum } from '../../../Common/Forms/enums/font-alignment.enum';
import { MonitoringImageStyleModel } from './monitoring-image-style.model';
import { MonitoringLayoutStyle } from './monitoring-layout-style.model';
import { LayoutBlockDisplayRatiosEnum } from '../../../Common/PageBuilder/enums/layout-block-display-ratios.enum';
import { VerticalAlignmentEnum } from '../../../Common/Forms/enums/vertical-alignment.enum';
import { DividerStyleModel } from '../../../Common/PageBuilder/models/divider-style.model';
import { SocialLinkStyleModel } from '../../../Common/PageBuilder/models/link-style.model';
import { LinkDisplayOptionEnum } from '../../../Common/PageBuilder/enums/link-display-option.enum';
import { LinkLayoutOptionEnum } from '../../../Common/PageBuilder/enums/link-layout-option.enum';
import { MonitoringTitleStyleModel } from './monitoring-title-style.model';
import { CuratorStyle } from '../../../Common/PageBuilder/models/curator-style.model';
import { PaddingModel } from '../../../Common/PageBuilder/models/padding.model';
import { ImageSizeEnum } from '../enums/image-size.enum';
import { CornerRadiusModel } from '@Common/PageBuilder/models/corner-radius.model';
import { MentionCardHeightEnum } from '../../../Common/Mentions/enums/mention-card-height.enum';

export const defaultBriefingStyleOne = {
    mention: new MentionCustomizationModel({
        mentionContent: 'lead',
        metadataTypes: ['outlet', 'outletIcon', 'author', 'publishedDate'],
        metadataOrder: ['outlet', 'author', 'publishedDate', 'audienceReach', 'ave', 'sentiment',
            'location', 'wordCount', 'duration', 'domainAuthority', 'engagement', 'mediaType', 'keywords', 'image'],
        mediaType: false,
        outletIcon: true,
        notes: false,
        enforceConcisePlayer: false,
        highlightKeywords: false,
        showInsights: false,
        displayInsightsName: false,
        insightsNameDisplay: 'insightsName',
        customInsightsName: 'Insight:',
        mentionInsightsLinkLabel: 'Get Insights',
        showSectionHeading: false,
        sectionHeading: {
            color: '#292929',
            fontFamily: DefaultFontsEnum.Arial,
            fontSize: '20px',
            bold: true,
            italics: false,
            underlined: false,
            alignment: 'left'
        },
        heading: {
            color: '#005494',
            fontFamily: DefaultFontsEnum.Arial,
            fontSize: '16px',
            bold: true,
            italics: false,
            underlined: false,
            alignment: 'left'
        },
        mentionInsightsLinkFont: {
            color: '#005494',
            fontFamily: DefaultFontsEnum.Arial,
            fontSize: '14px',
            bold: true,
            italics: false,
            underlined: false,
            alignment: 'left'
        },
        snippetFont: {
            color: '#292929',
            fontFamily: DefaultFontsEnum.Arial,
            fontSize: '14px',
            bold: false,
            italics: false,
            underlined: false
        },
        insightsFont: {
            color: '#292929',
            fontFamily: DefaultFontsEnum.Arial,
            fontSize: '14px',
            bold: false,
            italics: false,
            underlined: false,
            alignment: 'left'
        },
        metadataFont: {
            color: '#5e6473',
            fontFamily: DefaultFontsEnum.Arial,
            fontSize: '12px',
            bold: false,
            italics: false,
            underlined: false
        },
        notesFont: {
            color: '#292929',
            fontFamily: DefaultFontsEnum.Arial,
            fontSize: '12px',
            bold: false,
            italics: false,
            underlined: false
        },
        preferredCurrency: 'USD',
        timezone: 'UTC',
        styleState: BriefingStyleStateEnum.BRIEFING_1,
        backgroundColor: '#ffffff'
    }),
    title: new MonitoringTitleStyleModel({
        color: '#5e6473',
        fontSize: '24px',
        fontFamily: DefaultFontsEnum.Arial,
        styleState: BriefingStyleStateEnum.BRIEFING_1,
        bold: true,
        italics: false,
        underlined: false,
        alignment: FontAlignmentEnum.left,
        headingTwo: {
            color: '#5e6473',
            fontSize: '22px',
            fontFamily: DefaultFontsEnum.Arial,
            bold: true,
            italics: false,
            underlined: false,
            alignment: FontAlignmentEnum.left
        },
        headingThree: {
            color: '#5e6473',
            fontSize: '20px',
            fontFamily: DefaultFontsEnum.Arial,
            bold: true,
            italics: false,
            underlined: false,
            alignment: FontAlignmentEnum.left
        }
    }),
    text: new MonitoringTextStyleModel({
        color: '#292929',
        fontFamily: DefaultFontsEnum.Arial,
        fontSize: '14px',
        styleState: BriefingStyleStateEnum.BRIEFING_1,
        bold: false,
        italics: false,
        underlined: false
    }),
    analysis: new MonitoringTextStyleModel({
        color: '#292929',
        fontFamily: DefaultFontsEnum.Arial,
        styleState: BriefingStyleStateEnum.BRIEFING_1,
        fontSize: '14px',
        bold: false,
        italics: false,
        underlined: false
    }),
    link: new SocialLinkStyleModel({
        iconColor: 'light',
        backgroundColor: '#FFFFFF',
        iconSize: 'medium',
        iconShape: 4,
        displayOption: LinkDisplayOptionEnum.iconOnly,
        layoutOption: LinkLayoutOptionEnum.horizontal,
        iconBackgroundColor: '#101010',
        color: '#000000',
        fontFamily: DefaultFontsEnum.Arial,
        fontSize: '14px',
        bold: false,
        italics: false,
        underlined: true,
        alignment: 'center',
        styleState: BriefingStyleStateEnum.BRIEFING_1
    }),
    date: new MonitoringDateStyleModel({
        font: {
            color: '#292929',
            fontFamily: DefaultFontsEnum.Arial,
            fontSize: '14px',
            bold: true,
            italics: false,
            underlined: false
        },
        backgroundColor: '#f7f9fd',
        dateFormat: 'F d, Y',
        styleState: BriefingStyleStateEnum.BRIEFING_1
    }),
    tableOfContent:  new MonitoringTextStyleModel({
        color: '#005494',
        fontFamily: DefaultFontsEnum.Arial,
        fontSize: '14px',
        bold: false,
        italics: false,
        underlined: false,
        alignment: 'center',
        styleState: BriefingStyleStateEnum.BRIEFING_1
    }),
    image: new MonitoringImageStyleModel({
        color: '#292929',
        fontFamily: DefaultFontsEnum.Arial,
        styleState: BriefingStyleStateEnum.BRIEFING_1,
        fontSize: '14px',
        bold: false,
        italics: false,
        underlined: false,
        alignment: 'left',
        imageAlignment: FontAlignmentEnum.center,
        padding: new PaddingModel(0),
    }),
    divider: new DividerStyleModel({
        dividerColor: '#C7C7C7',
        height: 2,
        marginBottom: 20,
        marginTop: 20,
        styleState: BriefingStyleStateEnum.BRIEFING_1
    }),
    oneColumnLayout: new MonitoringLayoutStyle({
        backgroundColor: '#ffffff',
        styleState: BriefingStyleStateEnum.BRIEFING_1
    }),
    twoColumnLayout: new MonitoringLayoutStyle({
        displayRatio: LayoutBlockDisplayRatiosEnum.ONE_TO_ONE,
        width: ['50%', '50%'],
        backgroundColor: '#ffffff',
        verticalAlignment: VerticalAlignmentEnum.TOP,
        columnSpacing: 10,
        styleState: BriefingStyleStateEnum.BRIEFING_1
    }),
    threeColumnLayout: new MonitoringLayoutStyle({
        displayRatio: LayoutBlockDisplayRatiosEnum.ONE_TO_ONE_TO_ONE,
        width: ['33.33%', '33.33%', '33.33%'],
        backgroundColor: '#ffffff',
        verticalAlignment: VerticalAlignmentEnum.TOP,
        columnSpacing: 10,
        styleState: BriefingStyleStateEnum.BRIEFING_1
    }),
    chart: new MonitoringImageStyleModel({
        color: '#292929',
        fontFamily: DefaultFontsEnum.Arial,
        styleState: BriefingStyleStateEnum.BRIEFING_1,
        fontSize: '14px',
        bold: false,
        italics: false,
        underlined: false,
        alignment: FontAlignmentEnum.left,
        imageAlignment: FontAlignmentEnum.center,
        doBorder: false,
        borderWidth: 1,
        borderColor: '#ced4da',
        padding: new PaddingModel(20),
    }),
    covergeCurator: new CuratorStyle({
        backgroundColor: '#ffffff',
        styleState: BriefingStyleStateEnum.BRIEFING_1
    }),
};

export const defaultBriefingStyleTwo: any = {
    mention: new MentionCustomizationModel({
        mentionContent: 'lead',
        metadataTypes: ['outlet', 'outletIcon', 'author', 'publishedDate'],
        metadataOrder: ['outlet', 'author', 'publishedDate', 'audienceReach', 'ave', 'sentiment',
            'location', 'wordCount', 'duration', 'domainAuthority', 'engagement', 'mediaType', 'keywords', 'image'],
        mediaType: false,
        outletIcon: true,
        notes: false,
        enforceConcisePlayer: false,
        highlightKeywords: false,
        showInsights: false,
        displayInsightsName: false,
        insightsNameDisplay: 'insightsName',
        customInsightsName: 'Insight:',
        mentionInsightsLinkLabel: 'Get Insights',
        showSectionHeading: true,
        sectionHeading: {
            color: '#292929',
            fontFamily:  DefaultFontsEnum.Georgia,
            fontSize: '20px',
            bold: true,
            italics: false,
            underlined: false,
            alignment: 'center'
        },
        heading: {
            color: '#ff5126',
            fontFamily:  DefaultFontsEnum.Georgia,
            fontSize: '16px',
            bold: true,
            italics: false,
            underlined: false,
            alignment: 'left'
        },
        mentionInsightsLinkFont: {
            color: '#ff5126',
            fontFamily:  DefaultFontsEnum.Georgia,
            fontSize: '14px',
            bold: true,
            italics: false,
            underlined: false,
            alignment: 'left'
        },
        snippetFont: {
            color: '#292929',
            fontFamily:  DefaultFontsEnum.Georgia,
            fontSize: '14px',
            bold: false,
            italics: false,
            underlined: false
        },
        insightsFont: {
            color: '#292929',
            fontFamily: DefaultFontsEnum.Georgia,
            fontSize: '14px',
            bold: false,
            italics: false,
            underlined: false,
            alignment: 'left'
        },
        metadataFont: {
            color: '#5e6473',
            fontFamily:  DefaultFontsEnum.Georgia,
            fontSize: '12px',
            bold: false,
            italics: false,
            underlined: false
        },
        notesFont: {
            color: '#5e6473',
            fontFamily:  DefaultFontsEnum.Georgia,
            fontSize: '14px',
            bold: false,
            italics: true,
            underlined: false
        },
        preferredCurrency: 'USD',
        timezone: 'UTC',
        styleState: BriefingStyleStateEnum.BRIEFING_2,
        backgroundColor: '#ffffff'
    }),
    title: new MonitoringTitleStyleModel({
        color: '#ff5126',
        fontFamily:  DefaultFontsEnum.Georgia,
        fontSize: '24px',
        bold: true,
        italics: false,
        underlined: false,
        alignment:  FontAlignmentEnum.center,
        styleState: BriefingStyleStateEnum.BRIEFING_2,
        headingTwo: {
            color: '#ff5126',
            fontFamily:  DefaultFontsEnum.Georgia,
            fontSize: '22px',
            bold: true,
            italics: false,
            underlined: false,
            alignment:  FontAlignmentEnum.center,
        },
        headingThree: {
            color: '#ff5126',
            fontFamily:  DefaultFontsEnum.Georgia,
            fontSize: '20px',
            bold: true,
            italics: false,
            underlined: false,
            alignment:  FontAlignmentEnum.center,
        }
    }),
    text: new MonitoringTextStyleModel({
        color: '#292929',
        fontFamily:  DefaultFontsEnum.Georgia,
        fontSize: '14px',
        bold: false,
        italics: false,
        underlined: false,
        alignment: 'left',
        styleState: BriefingStyleStateEnum.BRIEFING_2
    }),
    analysis: new MonitoringTextStyleModel({
        color: '#292929',
        fontFamily:  DefaultFontsEnum.Georgia,
        fontSize: '14px',
        bold: false,
        italics: false,
        underlined: false,
        alignment: 'left',
        styleState: BriefingStyleStateEnum.BRIEFING_2
    }),
    date: new MonitoringDateStyleModel({
        font: {
            color: '#ffffff',
            fontFamily:  DefaultFontsEnum.Georgia,
            fontSize: '14px',
            bold: true,
            italics: false,
            underlined: false
        },
        backgroundColor: '#ff5126',
        dateFormat: 'Y-m-d',
        styleState: BriefingStyleStateEnum.BRIEFING_2
    }),
    tableOfContent:  new MonitoringTextStyleModel({
        color: '#ff5126',
        fontSize: '14px',
        bold: true,
        italics: false,
        underlined: false,
        alignment: 'center',
        fontFamily: DefaultFontsEnum.Georgia,
        styleState: BriefingStyleStateEnum.BRIEFING_2
    }),
    image: new MonitoringImageStyleModel({
        color: '#292929',
        fontFamily:  DefaultFontsEnum.Georgia,
        fontSize: '14px',
        bold: false,
        italics: false,
        underlined: false,
        alignment: 'left',
        styleState: BriefingStyleStateEnum.BRIEFING_2,
        imageAlignment: FontAlignmentEnum.left,
        padding: new PaddingModel(0),
    }),
    divider: new DividerStyleModel({
        dividerColor: '#ff5126',
        height: 1,
        marginBottom: 20,
        marginTop: 0,
        styleState: BriefingStyleStateEnum.BRIEFING_2
    }),
    chart: new MonitoringImageStyleModel({
        color: '#292929',
        fontFamily:  DefaultFontsEnum.Georgia,
        fontSize: '14px',
        bold: false,
        italics: false,
        underlined: false,
        alignment: FontAlignmentEnum.left,
        styleState: BriefingStyleStateEnum.BRIEFING_2,
        imageAlignment: FontAlignmentEnum.left,
        doBorder: false,
        borderWidth: 1,
        borderColor: '#ced4da',
        padding: new PaddingModel(20),
    }),
};

export const defaultBriefingStyleThree: any = {
    mention: new MentionCustomizationModel({
        mentionContent: 'lead',
        metadataTypes: ['outlet', 'outletIcon', 'author', 'publishedDate'],
        metadataOrder: ['outlet', 'author', 'publishedDate', 'audienceReach', 'ave', 'sentiment',
            'location', 'wordCount', 'duration', 'domainAuthority', 'engagement', 'mediaType', 'keywords', 'image'],
        mediaType: false,
        outletIcon: true,
        notes: false,
        enforceConcisePlayer: false,
        highlightKeywords: false,
        showInsights: false,
        displayInsightsName: false,
        insightsNameDisplay: 'insightsName',
        customInsightsName: 'Insight:',
        mentionInsightsLinkLabel: 'Get Insights',
        showSectionHeading: true,
        sectionHeading: {
            color: '#292929',
            fontFamily: DefaultFontsEnum.Arial,
            fontSize: '20px',
            bold: false,
            italics: false,
            underlined: false,
            alignment: 'left'
        },
        heading: {
            color: '#292929',
            fontFamily: DefaultFontsEnum.Arial,
            fontSize: '16px',
            bold: true,
            italics: false,
            underlined: true,
            alignment: 'left'
        },
        mentionInsightsLinkFont: {
            color: '#292929',
            fontFamily: DefaultFontsEnum.Arial,
            fontSize: '14px',
            bold: true,
            italics: false,
            underlined: true,
            alignment: 'left'
        },
        snippetFont: {
            color: '#292929',
            fontFamily: DefaultFontsEnum.Arial,
            fontSize: '14px',
            bold: false,
            italics: false,
            underlined: false
        },
        insightsFont: {
            color: '#292929',
            fontFamily: DefaultFontsEnum.Arial,
            fontSize: '14px',
            bold: false,
            italics: false,
            underlined: false,
            alignment: 'left'
        },
        metadataFont: {
            color: '#5e6473',
            fontFamily: DefaultFontsEnum.Arial,
            fontSize: '12px',
            bold: false,
            italics: false,
            underlined: false
        },
        notesFont: {
            color: '#5e6473',
            fontFamily: DefaultFontsEnum.Arial,
            fontSize: '14px',
            bold: false,
            italics: true,
            underlined: false
        },
        preferredCurrency: 'USD',
        timezone: 'UTC',
        styleState: BriefingStyleStateEnum.BRIEFING_3,
        backgroundColor: '#ffffff'
    }),
    title: new MonitoringTitleStyleModel({
        alignment: FontAlignmentEnum.center,
        backgroundColor: '#444444',
        color: '#5e6473',
        fontSize: '24px',
        fontFamily: DefaultFontsEnum.Arial,
        styleState: BriefingStyleStateEnum.BRIEFING_3,
        bold: true,
        italics: false,
        underlined: false,
        headingTwo: {
            alignment: FontAlignmentEnum.center,
            backgroundColor: '#444444',
            color: '#5e6473',
            fontSize: '22px',
            fontFamily: DefaultFontsEnum.Arial,
            bold: true,
            italics: false,
            underlined: false,
        },
        headingThree: {
            alignment: FontAlignmentEnum.center,
            backgroundColor: '#444444',
            color: '#5e6473',
            fontSize: '20px',
            fontFamily: DefaultFontsEnum.Arial,
            bold: true,
            italics: false,
            underlined: false,
        }
    }),
    text: new MonitoringTextStyleModel({
        color: '#292929',
        fontFamily: DefaultFontsEnum.Arial,
        fontSize: '14px',
        styleState: BriefingStyleStateEnum.BRIEFING_3,
        bold: false,
        italics: false,
        underlined: false
    }),
    analysis: new MonitoringTextStyleModel({
        color: '#292929',
        fontFamily: DefaultFontsEnum.Arial,
        styleState: BriefingStyleStateEnum.BRIEFING_3,
        bold: false,
        fontSize: '14px',
        italics: false,
        underlined: false
    }),
    date: new MonitoringDateStyleModel({
        textColor: '#000000',
        backgroundColor: '#ffffff',
        fontFamily: DefaultFontsEnum.Arial,
        dateFormat: 'F d, Y',
        styleState: BriefingStyleStateEnum.BRIEFING_3
    }),
    tableOfContent:  new MonitoringTextStyleModel({
        color: '#292929',
        fontSize: '14px',
        fontFamily: DefaultFontsEnum.Arial,
        bold: false,
        italics: false,
        underlined: false,
        alignment: 'center',
        styleState: BriefingStyleStateEnum.BRIEFING_3
    }),
    image: new MonitoringImageStyleModel({
        color: '#5e6473',
        fontFamily: DefaultFontsEnum.Arial,
        styleState: BriefingStyleStateEnum.BRIEFING_3,
        fontSize: '14px',
        bold: true,
        italics: false,
        underlined: false,
        imageAlignment: FontAlignmentEnum.center,
        padding: new PaddingModel(0),
    }),
    divider: new DividerStyleModel({
        dividerColor: '#C7C7C7',
        height: 2,
        marginBottom: 20,
        marginTop: 20,
        styleState: BriefingStyleStateEnum.BRIEFING_3
    }),
    chart: new MonitoringImageStyleModel({
        color: '#5e6473',
        fontFamily: DefaultFontsEnum.Arial,
        styleState: BriefingStyleStateEnum.BRIEFING_3,
        fontSize: '14px',
        bold: true,
        italics: false,
        underlined: false,
        alignment: FontAlignmentEnum.left,
        imageAlignment: FontAlignmentEnum.center,
        doBorder: false,
        borderWidth: 1,
        borderColor: '#ced4da',
        padding: new PaddingModel(20),
    }),
};

export const defaultCanvasStyleOne = {
    mention: new MentionCustomizationModel({
        mentionContent: 'lead',
        metadataTypes: ['mediaType', 'outlet', 'outletIcon', 'author', 'image', 'publishedDate'],
        metadataOrder: ['outlet', 'author', 'publishedDate', 'audienceReach', 'ave', 'sentiment',
            'location', 'wordCount', 'duration', 'domainAuthority', 'engagement', 'mediaType', 'keywords', 'image'],
        mediaType: true,
        outletIcon: true,
        image: true,
        imageSize: ImageSizeEnum.fullWidth,
        notes: false,
        enforceConcisePlayer: false,
        highlightKeywords: false,
        showInsights: false,
        displayInsightsName: false,
        insightsNameDisplay: 'insightsName',
        customInsightsName: 'Insight:',
        mentionInsightsLinkLabel: 'Get Insights',
        showSectionHeading: false,
        cardHeight: MentionCardHeightEnum.fixed,
        sectionHeading: {
            color: '#000000',
            fontFamily: DefaultFontsEnum.Verdana,
            fontSize: '20px',
            bold: true,
            italics: false,
            underlined: false,
            alignment: 'left'
        },
        heading: {
            color: '#005494',
            fontFamily: DefaultFontsEnum.Verdana,
            fontSize: '16px',
            bold: true,
            italics: false,
            underlined: false,
            alignment: 'left'
        },
        mentionInsightsLinkFont: {
            color: '#005494',
            fontFamily: DefaultFontsEnum.Verdana,
            fontSize: '14px',
            bold: true,
            italics: false,
            underlined: false,
            alignment: 'left'
        },
        snippetFont: {
            color: '#000000',
            fontFamily: DefaultFontsEnum.Verdana,
            fontSize: '14px',
            bold: false,
            italics: false,
            underlined: false
        },
        insightsFont: {
            color: '#000000',
            fontFamily: DefaultFontsEnum.Verdana,
            fontSize: '14px',
            bold: false,
            italics: false,
            underlined: false,
            alignment: 'left'
        },
        metadataFont: {
            color: '#000000',
            fontFamily: DefaultFontsEnum.Verdana,
            fontSize: '12px',
            bold: false,
            italics: false,
            underlined: false
        },
        notesFont: {
            color: '#292929',
            fontFamily: DefaultFontsEnum.Verdana,
            fontSize: '12px',
            bold: false,
            italics: false,
            underlined: false
        },
        preferredCurrency: 'USD',
        timezone: 'UTC',
        styleState: BriefingStyleStateEnum.CANVAS_1,
        backgroundColor: '#ffffff'
    }),
    title: new MonitoringTitleStyleModel({
        color: '#000000',
        fontSize: '28px',
        fontFamily: DefaultFontsEnum.Verdana,
        styleState: BriefingStyleStateEnum.CANVAS_1,
        bold: false,
        italics: false,
        underlined: false,
        alignment: FontAlignmentEnum.center,
        padding: new PaddingModel(0, true, 20, 0, 20, 0),
        headingTwo: {
            color: '#000000',
            fontSize: '22px',
            fontFamily: DefaultFontsEnum.Verdana,
            bold: false,
            italics: false,
            underlined: false,
            alignment: FontAlignmentEnum.left,
            padding: new PaddingModel(0, true, 50, 0, 10, 0)
        },
        headingThree: {
            color: '#000000',
            fontSize: '18px',
            fontFamily: DefaultFontsEnum.Verdana,
            bold: false,
            italics: false,
            underlined: false,
            alignment: FontAlignmentEnum.left,
            padding: new PaddingModel(0, true, 30, 0, 10, 0)
        }
    }),
    text: new MonitoringTextStyleModel({
        color: '#000000',
        fontFamily: DefaultFontsEnum.Verdana,
        fontSize: '14px',
        styleState: BriefingStyleStateEnum.CANVAS_1,
        bold: false,
        italics: false,
        underlined: false,
        padding: new PaddingModel(0, true, 0, 0, 20, 0)
    }),
    analysis: new MonitoringTextStyleModel({
        color: '#000000',
        fontFamily: DefaultFontsEnum.Verdana,
        styleState: BriefingStyleStateEnum.CANVAS_1,
        fontSize: '14px',
        bold: false,
        italics: false,
        underlined: false,
        padding: new PaddingModel(0, true, 0, 0, 20, 0)
    }),
    link: new SocialLinkStyleModel({
        iconColor: 'light',
        backgroundColor: '#FFFFFF',
        iconSize: 'medium',
        iconShape: 4,
        displayOption: LinkDisplayOptionEnum.iconOnly,
        layoutOption: LinkLayoutOptionEnum.horizontal,
        iconBackgroundColor: '#101010',
        color: '#000000',
        fontFamily: DefaultFontsEnum.Verdana,
        fontSize: '14px',
        bold: false,
        italics: false,
        underlined: true,
        alignment: 'center',
        styleState: BriefingStyleStateEnum.CANVAS_1
    }),
    date: new MonitoringDateStyleModel({
        font: {
            color: '#292929',
            fontFamily: DefaultFontsEnum.Verdana,
            fontSize: '14px',
            bold: false,
            italics: false,
            underlined: false
        },
        backgroundColor: '#f7f9fd',
        dateFormat: 'F d, Y',
        padding: new PaddingModel(null, true, 10, 20, 10, 20),
        styleState: BriefingStyleStateEnum.CANVAS_1
    }),
    tableOfContent:  new MonitoringTextStyleModel({
        color: '#005494',
        fontFamily: DefaultFontsEnum.Verdana,
        fontSize: '14px',
        bold: false,
        italics: false,
        underlined: false,
        alignment: 'center',
        styleState: BriefingStyleStateEnum.CANVAS_1
    }),
    image: new MonitoringImageStyleModel({
        color: '#000000',
        fontFamily: DefaultFontsEnum.Verdana,
        styleState: BriefingStyleStateEnum.CANVAS_1,
        fontSize: '14px',
        bold: false,
        italics: false,
        underlined: false,
        alignment: 'left',
        imageAlignment: FontAlignmentEnum.center,
        padding: new PaddingModel(0),
        cornerRadius: new CornerRadiusModel(0, false)
    }),
    divider: new DividerStyleModel({
        dividerColor: '#C7C7C7',
        height: 2,
        marginBottom: 20,
        marginTop: 20,
        styleState: BriefingStyleStateEnum.CANVAS_1
    }),
    oneColumnLayout: new MonitoringLayoutStyle({
        backgroundColor: '#ffffff',
        styleState: BriefingStyleStateEnum.CANVAS_1,
        cornerRadius: new CornerRadiusModel(0, false)
    }),
    twoColumnLayout: new MonitoringLayoutStyle({
        displayRatio: LayoutBlockDisplayRatiosEnum.ONE_TO_ONE,
        width: ['50%', '50%'],
        backgroundColor: '#ffffff',
        verticalAlignment: VerticalAlignmentEnum.TOP,
        columnSpacing: 20,
        styleState: BriefingStyleStateEnum.CANVAS_1,
        padding: new PaddingModel(0, true, 0, 0, 0, 0),
        cornerRadius: new CornerRadiusModel(0, false)
    }),
    threeColumnLayout: new MonitoringLayoutStyle({
        displayRatio: LayoutBlockDisplayRatiosEnum.ONE_TO_ONE_TO_ONE,
        width: ['33.33%', '33.33%', '33.33%'],
        backgroundColor: '#ffffff',
        verticalAlignment: VerticalAlignmentEnum.TOP,
        columnSpacing: 10,
        styleState: BriefingStyleStateEnum.CANVAS_1,
        cornerRadius: new CornerRadiusModel(0, false)
    }),
    chart: new MonitoringImageStyleModel({
        color: '#292929',
        fontFamily: DefaultFontsEnum.Verdana,
        styleState: BriefingStyleStateEnum.CANVAS_1,
        fontSize: '14px',
        bold: false,
        italics: false,
        underlined: false,
        alignment: FontAlignmentEnum.left,
        imageAlignment: FontAlignmentEnum.center,
        doBorder: true,
        borderWidth: 1,
        borderColor: '#ced4da',
        padding: new PaddingModel(20),
        cornerRadius: new CornerRadiusModel(12, false)
    }),
    coverageCurator: new CuratorStyle({
        backgroundColor: '#ffffff',
        styleState: BriefingStyleStateEnum.CANVAS_1
    }),
};

export const defaultBriefingStyles: any = {
    [BriefingStyleStateEnum.DEFAULT]: defaultBriefingStyleOne,
    [BriefingStyleStateEnum.BRIEFING_1]: defaultBriefingStyleOne,
    [BriefingStyleStateEnum.BRIEFING_2]: defaultBriefingStyleTwo,
    [BriefingStyleStateEnum.BRIEFING_3]: defaultBriefingStyleThree,
    [BriefingStyleStateEnum.CANVAS_1]: defaultCanvasStyleOne
};

// don't think we are using this anywhere
// New Branding
// export const newBrandingDefaultBriefingStyleOne = {
//     mention: new MentionCustomizationModel({
//         mentionContent: 'lead',
//         metadataTypes: ['outlet', 'outletIcon', 'author', 'publishedDate'],
//         metadataOrder: ['outlet', 'author', 'publishedDate', 'audienceReach', 'ave', 'sentiment',
//             'location', 'wordCount', 'duration', 'domainAuthority', 'engagement', 'mediaType', 'keywords', 'image'],
//         mediaType: false,
//         outletIcon: true,
//         notes: false,
//         enforceConcisePlayer: false,
//         highlightKeywords: false,
//         showInsights: false,
//         displayInsightsName: false,
//         insightsNameDisplay: 'insightsName',
//         customInsightsName: 'Insight:',
//         mentionInsightsLinkLabel: 'Get Insights',
//         showSectionHeading: true,
//         sectionHeading: {
//             color: '#1e1e1e',
//             fontFamily: DefaultFontsEnum.Arial,
//             fontSize: '20px',
//             bold: true,
//             italics: false,
//             underlined: false,
//             alignment: 'left'
//         },
//         heading: {
//             color: '#231F44',
//             fontFamily: DefaultFontsEnum.Arial,
//             fontSize: '16px',
//             bold: true,
//             italics: false,
//             underlined: false,
//             alignment: 'left'
//         },
//         mentionInsightsLinkFont: {
//             color: '#231F44',
//             fontFamily: DefaultFontsEnum.Arial,
//             fontSize: '14px',
//             bold: true,
//             italics: false,
//             underlined: false,
//             alignment: 'left'
//         },
//         snippetFont: {
//             color: '#1e1e1e',
//             fontFamily: DefaultFontsEnum.Arial,
//             fontSize: '14px',
//             bold: false,
//             italics: false,
//             underlined: false
//         },
//         insightsFont: {
//             color: '#1e1e1e',
//             fontFamily: DefaultFontsEnum.Arial,
//             fontSize: '14px',
//             bold: false,
//             italics: false,
//             underlined: false,
//             alignment: 'left'
//         },
//         metadataFont: {
//             color: '#5e6473',
//             fontFamily: DefaultFontsEnum.Arial,
//             fontSize: '12px',
//             bold: false,
//             italics: false,
//             underlined: false
//         },
//         notesFont: {
//             color: '#1e1e1e',
//             fontFamily: DefaultFontsEnum.Arial,
//             fontSize: '12px',
//             bold: false,
//             italics: false,
//             underlined: false
//         },
//         preferredCurrency: 'USD',
//         timezone: 'UTC',
//         styleState: BriefingStyleStateEnum.BRIEFING_1,
//         backgroundColor: '#ffffff'
//     }),
//     title: new MonitoringTitleStyleModel({
//         color: '#5e6473',
//         fontSize: '24px',
//         fontFamily: DefaultFontsEnum.Arial,
//         styleState: BriefingStyleStateEnum.BRIEFING_1,
//         bold: true,
//         italics: false,
//         underlined: false,
//         alignment: FontAlignmentEnum.left,
//         headingTwo: {
//             color: '#5e6473',
//             fontSize: '22px',
//             fontFamily: DefaultFontsEnum.Arial,
//             bold: true,
//             italics: false,
//             underlined: false,
//             alignment: FontAlignmentEnum.left,
//         },
//         headingThree: {
//             color: '#5e6473',
//             fontSize: '20px',
//             fontFamily: DefaultFontsEnum.Arial,
//             bold: true,
//             italics: false,
//             underlined: false,
//             alignment: FontAlignmentEnum.left,
//         }
//     }),
//     text: new MonitoringTextStyleModel({
//         color: '#1e1e1e',
//         fontFamily: DefaultFontsEnum.Arial,
//         fontSize: '14px',
//         styleState: BriefingStyleStateEnum.BRIEFING_1,
//         bold: false,
//         italics: false,
//         underlined: false
//     }),
//     analysis: new MonitoringTextStyleModel({
//         color: '#1e1e1e',
//         fontFamily: DefaultFontsEnum.Arial,
//         styleState: BriefingStyleStateEnum.BRIEFING_1,
//         bold: false,
//         fontSize: '14px',
//         italics: false,
//         underlined: false
//     }),
//     date: new MonitoringDateStyleModel({
//         font: {
//             color: '#ffffff',
//             fontFamily: DefaultFontsEnum.Arial,
//             fontSize: '14px',
//             bold: true,
//             italics: false,
//             underlined: false
//         },
//         backgroundColor: '#231F44',
//         dateFormat: 'F d, Y',
//         styleState: BriefingStyleStateEnum.BRIEFING_1
//     }),
//     tableOfContent:  new MonitoringTextStyleModel({
//         color: '#231F44',
//         fontFamily: DefaultFontsEnum.Arial,
//         fontSize: '14px',
//         bold: false,
//         italics: false,
//         underlined: false,
//         alignment: 'center',
//         styleState: BriefingStyleStateEnum.BRIEFING_1
//     }),
//     image: new MonitoringImageStyleModel({
//         color: '#1e1e1e',
//         fontFamily: DefaultFontsEnum.Arial,
//         styleState: BriefingStyleStateEnum.BRIEFING_1,
//         fontSize: '14px',
//         bold: false,
//         italics: false,
//         underlined: false,
//         alignment: 'left',
//         imageAlignment: FontAlignmentEnum.center
//     }),
//     oneColumnLayout: new MonitoringLayoutStyle({
//         backgroundColor: '#ffffff',
//         styleState: BriefingStyleStateEnum.BRIEFING_1
//     }),
//     twoColumnLayout: new MonitoringLayoutStyle({
//         displayRatio: LayoutBlockDisplayRatiosEnum.ONE_TO_ONE,
//         backgroundColor: '#ffffff',
//         verticalAlignment: VerticalAlignmentEnum.TOP,
//         columnSpacing: 10,
//         styleState: BriefingStyleStateEnum.BRIEFING_1
//     }),
//     threeColumnLayout: new MonitoringLayoutStyle({
//         displayRatio: LayoutBlockDisplayRatiosEnum.ONE_TO_ONE_TO_ONE,
//         backgroundColor: '#ffffff',
//         verticalAlignment: VerticalAlignmentEnum.TOP,
//         columnSpacing: 10,
//         styleState: BriefingStyleStateEnum.BRIEFING_1
//     }),
//     coverageCurator: new CuratorStyle({
//         backgroundColor: '#ffffff',
//         styleState: BriefingStyleStateEnum.BRIEFING_1
//     }),
// };

// export const newBrandingDefaultBriefingStyleTwo: any = {
//     mention: new MentionCustomizationModel({
//         mentionContent: 'lead',
//         metadataTypes: ['outlet', 'outletIcon', 'author', 'publishedDate'],
//         metadataOrder: ['outlet', 'author', 'publishedDate', 'audienceReach', 'ave', 'sentiment',
//             'location', 'wordCount', 'duration', 'domainAuthority', 'engagement', 'mediaType', 'keywords', 'image'],
//         mediaType: false,
//         outletIcon: true,
//         notes: false,
//         enforceConcisePlayer: false,
//         highlightKeywords: false,
//         showInsights: false,
//         displayInsightsName: false,
//         insightsNameDisplay: 'insightsName',
//         customInsightsName: 'Insight:',
//         mentionInsightsLinkLabel: 'Get Insights',
//         showSectionHeading: true,
//         sectionHeading: {
//             color: '#1e1e1e',
//             fontFamily:  DefaultFontsEnum.Georgia,
//             fontSize: '20px',
//             bold: true,
//             italics: false,
//             underlined: false,
//             alignment: 'center'
//         },
//         heading: {
//             color: '#231F44',
//             fontFamily:  DefaultFontsEnum.Georgia,
//             fontSize: '16px',
//             bold: true,
//             italics: false,
//             underlined: false,
//             alignment: 'left'
//         },
//         mentionInsightsLinkFont: {
//             color: '#231F44',
//             fontFamily:  DefaultFontsEnum.Georgia,
//             fontSize: '14px',
//             bold: true,
//             italics: false,
//             underlined: false,
//             alignment: 'left'
//         },
//         snippetFont: {
//             color: '#1e1e1e',
//             fontFamily:  DefaultFontsEnum.Georgia,
//             fontSize: '14px',
//             bold: false,
//             italics: false,
//             underlined: false
//         },
//         insightsFont: {
//             color: '#1e1e1e',
//             fontFamily: DefaultFontsEnum.Georgia,
//             fontSize: '14px',
//             bold: false,
//             italics: false,
//             underlined: false,
//             alignment: 'left'
//         },
//         metadataFont: {
//             color: '#5e6473',
//             fontFamily:  DefaultFontsEnum.Georgia,
//             fontSize: '12px',
//             bold: false,
//             italics: false,
//             underlined: false
//         },
//         notesFont: {
//             color: '#5e6473',
//             fontFamily:  DefaultFontsEnum.Georgia,
//             fontSize: '14px',
//             bold: false,
//             italics: true,
//             underlined: false
//         },
//         preferredCurrency: 'USD',
//         timezone: 'UTC',
//         styleState: BriefingStyleStateEnum.BRIEFING_2,
//         backgroundColor: '#ffffff'
//     }),
//     title: new MonitoringTitleStyleModel({
//         color: '#231F44',
//         fontFamily:  DefaultFontsEnum.Georgia,
//         fontSize: '24px',
//         bold: true,
//         italics: false,
//         underlined: false,
//         alignment:  FontAlignmentEnum.center,
//         styleState: BriefingStyleStateEnum.BRIEFING_2,
//         headingTwo: {
//             color: '#231F44',
//             fontFamily:  DefaultFontsEnum.Georgia,
//             fontSize: '22px',
//             bold: true,
//             italics: false,
//             underlined: false,
//             alignment:  FontAlignmentEnum.center,
//         },
//         headingThree: {
//             color: '#231F44',
//             fontFamily:  DefaultFontsEnum.Georgia,
//             fontSize: '20px',
//             bold: true,
//             italics: false,
//             underlined: false,
//             alignment:  FontAlignmentEnum.center,
//         }
//     }),
//     text: new MonitoringTextStyleModel({
//         color: '#1e1e1e',
//         fontFamily:  DefaultFontsEnum.Georgia,
//         fontSize: '14px',
//         bold: false,
//         italics: false,
//         underlined: false,
//         alignment: 'left',
//         styleState: BriefingStyleStateEnum.BRIEFING_2
//     }),
//     analysis: new MonitoringTextStyleModel({
//         color: '#1e1e1e',
//         fontFamily:  DefaultFontsEnum.Georgia,
//         fontSize: '14px',
//         bold: false,
//         italics: false,
//         underlined: false,
//         alignment: 'left',
//         styleState: BriefingStyleStateEnum.BRIEFING_2
//     }),
//     date: new MonitoringDateStyleModel({
//         font: {
//             color: '#ffffff',
//             fontFamily:  DefaultFontsEnum.Georgia,
//             fontSize: '14px',
//             bold: true,
//             italics: false,
//             underlined: false
//         },
//         backgroundColor: '#231F44',
//         dateFormat: 'Y-m-d',
//         styleState: BriefingStyleStateEnum.BRIEFING_2
//     }),
//     tableOfContent:  new MonitoringTextStyleModel({
//         color: '#231F44',
//         fontSize: '14px',
//         bold: true,
//         italics: false,
//         underlined: false,
//         alignment: 'center',
//         fontFamily: DefaultFontsEnum.Georgia,
//         styleState: BriefingStyleStateEnum.BRIEFING_2
//     }),
//     image: new MonitoringImageStyleModel({
//         color: '#1e1e1e',
//         fontFamily:  DefaultFontsEnum.Georgia,
//         fontSize: '14px',
//         bold: false,
//         italics: false,
//         underlined: false,
//         alignment: 'left',
//         styleState: BriefingStyleStateEnum.BRIEFING_2,
//         imageAlignment: FontAlignmentEnum.left
//     })
// };

// export const newBrandingDefaultBriefingStyleThree: any = {
//     mention: new MentionCustomizationModel({
//         mentionContent: 'lead',
//         metadataTypes: ['outlet', 'outletIcon', 'author', 'publishedDate'],
//         metadataOrder: ['outlet', 'author', 'publishedDate', 'audienceReach', 'ave', 'sentiment',
//             'location', 'wordCount', 'duration', 'domainAuthority', 'engagement', 'mediaType', 'keywords', 'image'],
//         mediaType: false,
//         outletIcon: true,
//         notes: false,
//         enforceConcisePlayer: false,
//         highlightKeywords: false,
//         showInsights: false,
//         displayInsightsName: false,
//         insightsNameDisplay: 'insightsName',
//         customInsightsName: 'Insight:',
//         mentionInsightsLinkLabel: 'Get Insights',
//         showSectionHeading: true,
//         sectionHeading: {
//             color: '#231F44',
//             fontFamily: DefaultFontsEnum.Arial,
//             fontSize: '20px',
//             bold: false,
//             italics: false,
//             underlined: false,
//             alignment: 'left'
//         },
//         heading: {
//             color: '#1e1e1e',
//             fontFamily: DefaultFontsEnum.Arial,
//             fontSize: '16px',
//             bold: true,
//             italics: false,
//             underlined: true,
//             alignment: 'left'
//         },
//         mentionInsightsLinkFont: {
//             color: '#1e1e1e',
//             fontFamily: DefaultFontsEnum.Arial,
//             fontSize: '14px',
//             bold: true,
//             italics: false,
//             underlined: true,
//             alignment: 'left'
//         },
//         snippetFont: {
//             color: '#1e1e1e',
//             fontFamily: DefaultFontsEnum.Arial,
//             fontSize: '14px',
//             bold: false,
//             italics: false,
//             underlined: false
//         },
//         insightsFont: {
//             color: '#1e1e1e',
//             fontFamily: DefaultFontsEnum.Arial,
//             fontSize: '14px',
//             bold: false,
//             italics: false,
//             underlined: false,
//             alignment: 'left'
//         },
//         metadataFont: {
//             color: '#5e6473',
//             fontFamily: DefaultFontsEnum.Arial,
//             fontSize: '12px',
//             bold: false,
//             italics: false,
//             underlined: false
//         },
//         notesFont: {
//             color: '#5e6473',
//             fontFamily: DefaultFontsEnum.Arial,
//             fontSize: '14px',
//             bold: false,
//             italics: true,
//             underlined: false
//         },
//         preferredCurrency: 'USD',
//         timezone: 'UTC',
//         styleState: BriefingStyleStateEnum.BRIEFING_3,
//         backgroundColor: '#ffffff'
//     }),
//     title: new MonitoringTitleStyleModel({
//         alignment: FontAlignmentEnum.center,
//         backgroundColor: '#444444',
//         color: '#e5e5e5',
//         fontFamily: DefaultFontsEnum.Arial,
//         styleState: BriefingStyleStateEnum.BRIEFING_3,
//         bold: true,
//         italics: false,
//         underlined: false,
//         headingTwo: {
//             alignment: FontAlignmentEnum.center,
//             backgroundColor: '#444444',
//             color: '#e5e5e5',
//             fontFamily: DefaultFontsEnum.Arial,
//             bold: true,
//             italics: false,
//             underlined: false,
//         },
//         headingThree: {
//             alignment: FontAlignmentEnum.center,
//             backgroundColor: '#444444',
//             color: '#e5e5e5',
//             fontFamily: DefaultFontsEnum.Arial,
//             bold: true,
//             italics: false,
//             underlined: false,
//         }
//     }),
//     text: new MonitoringTextStyleModel({
//         color: '#1e1e1e',
//         fontSize: '14px',
//         fontFamily: DefaultFontsEnum.Arial,
//         styleState: BriefingStyleStateEnum.BRIEFING_3,
//         bold: false,
//         italics: false,
//         underlined: false
//     }),
//     analysis: new MonitoringTextStyleModel({
//         color: '#1e1e1e',
//         fontFamily: DefaultFontsEnum.Arial,
//         styleState: BriefingStyleStateEnum.BRIEFING_3,
//         bold: false,
//         fontSize: '14px',
//         italics: false,
//         underlined: false
//     }),
//     date: new MonitoringDateStyleModel({
//         textColor: '#000000',
//         backgroundColor: '#ffffff',
//         fontFamily: DefaultFontsEnum.Arial,
//         dateFormat: 'F d, Y',
//         styleState: BriefingStyleStateEnum.BRIEFING_3
//     }),
//     tableOfContent:  new MonitoringTextStyleModel({
//         color: '#231F44',
//         fontSize: '14px',
//         fontFamily: DefaultFontsEnum.Arial,
//         bold: false,
//         italics: false,
//         underlined: false,
//         alignment: 'center',
//         styleState: BriefingStyleStateEnum.BRIEFING_3
//     }),
//     image: new MonitoringImageStyleModel({
//         color: '#5e6473',
//         fontFamily: DefaultFontsEnum.Arial,
//         styleState: BriefingStyleStateEnum.BRIEFING_3,
//         fontSize: '14px',
//         bold: true,
//         italics: false,
//         underlined: false,
//         imageAlignment: FontAlignmentEnum.center
//     })
// };

// export const newBrandingDefaultBriefingStyles: any = {
//     [BriefingStyleStateEnum.DEFAULT]: newBrandingDefaultBriefingStyleOne,
//     [BriefingStyleStateEnum.BRIEFING_1]: newBrandingDefaultBriefingStyleOne,
//     [BriefingStyleStateEnum.BRIEFING_2]: newBrandingDefaultBriefingStyleTwo,
//     [BriefingStyleStateEnum.BRIEFING_3]: newBrandingDefaultBriefingStyleThree
// };
